import axios from "axios";
import React from "react";
import {Button, StyleSheet} from 'react-native';
import {TextGenre, TextTitle} from "../components/StyledText";
import {View} from '../components/Themed';

export default class TabOneScreen extends React.Component<any, any> {

    public static state = {currentMovie: []};

    constructor(props: any) {
        super(props);

        this.state = {
            currentMovie: []
        }
    }

    render() {
        return (
            <View style={styles.container}>
                {this.renderContent()}
                <br/>
                <Button title={"Randomize Movie"} onPress={this.onPress}/>
            </View>
        );
    }

    private renderContent() {
        const {currentMovie} = this.state;

        if (currentMovie.length !== 0) {
            const idx = this.extract(0)
            const title = this.extract(1)
            const year = this.extract(2)
            const genre = this.extract(3)
            const img = this.extract(4)
            const splittedImg = img[0].split("/v2/");
            const imgOrig = splittedImg[1]
            const meter = this.extract(5)
            const audience = this.extract(6)
            const innerlink = this.extract(7)

            return <div style={{textAlign: "center"}}>
                <TextTitle>{title} {year} <b>{meter}</b></TextTitle>
                <TextGenre>{genre}</TextGenre>
                <br/>
                <a target={"_blank"} href={innerlink}>
                    <img src={imgOrig} height="450px" width="300px"/>
                </a>
            </div>
        }
    }

    private extract(i: any) {
        const {currentMovie} = this.state;
        if (currentMovie.length !== 0) {
            return Object.keys(currentMovie[i]).map(x => currentMovie[i][x]);
        }
    }

    private onPress = async () => {
        const result = await axios.get("https://movies.dsserv.de/api");

        if (result.data && result.data.data) {
            this.setState({
                currentMovie: result.data.data
            })
        }
    }
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
    },
    title: {
        fontSize: 20,
        fontWeight: 'bold',
    },
    separator: {
        marginVertical: 30,
        height: 1,
        width: '80%',
    },
});
